import {React,useState,useEffect} from 'react';
import axios from 'axios';
import './MyMarquee.css';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const API_BASE_URL = 'http://127.0.0.1:8000';

function MyMarquee() {
   const [marqueeText, setMarqueeText] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchMarqueeText();
  }, []);

  const fetchMarqueeText = async () => {
    try {
     const response = await axios.get(`${API_BASE_URL}/api/marquee`);
      setMarqueeText(response.data.marquee_text);
      setLoading(false);
    } catch (error) {
      setError('Error fetching marquee text');
      setLoading(false);
    }
  };

  if (loading) {
    return <div>...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
   <>
   {marqueeText.trim() !== '' &&
    <div className="marquee-container my-2">
      <div className="marquee-content">
      <h6>{marqueeText}</h6>
      
      </div>
    
    </div>
}
         </>
  );
}

export default MyMarquee;